<app-quick-action-dialog
  [isOpen]="isDialogOpen"
  [title]="dialogTitle()"
  [isCloseable]="true"
  (backdropClick)="onBackdropClick()"
  (close)="onClose()"
>
  <!-- Content slot for form -->
  <div slot="content" class="wallet-form">
    <kc-input
      [infoLabel]="{ label: 'Wallet name' }"
      [placeholder]="'Enter wallet name'"
      [(ngModel)]="walletName"
    />
  </div>

  <!-- Footer slot for action button -->
  <div slot="footer">
    <kc-button
      [text]="buttonText()"
      [variant]="'primary'"
      [size]="'m'"
      [isFullWidth]="true"
      [isDisabled]="!walletName.trim()"
      (buttonClick)="onSaveWallet()"
    />
  </div>
</app-quick-action-dialog>
